export default __webpack_public_path__ + "static/home-slide001-960e7c8dd2b643679cbd779114c7d1a3.jpg";